var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 26H31.5C31.75 26 32 26.25 32 26.5V27.5C32 27.8125 31.75 28 31.5 28H1C0.4375 28 0 27.5625 0 27V4.5C0 4.25 0.1875 4 0.5 4H1.5C1.75 4 2 4.25 2 4.5V26ZM29.0072 12.3809C29.2312 12.1366 29.2146 11.7571 28.9704 11.5331L28.3807 10.9926C28.1364 10.7686 27.7568 10.7851 27.5329 11.0294L20.6665 18.5201L14.0703 11.3243C13.8809 11.1177 13.6134 11 13.3331 11C13.0528 11 12.7854 11.1177 12.596 11.3243L4.99235 19.6191C4.76843 19.8634 4.78493 20.243 5.02921 20.4669L5.61893 21.0075C5.8632 21.2314 6.24274 21.2149 6.46666 20.9706L13.3331 13.4799L19.9293 20.6757C20.1187 20.8824 20.3862 21 20.6665 21C20.9468 21 21.2142 20.8824 21.4036 20.6757L29.0072 12.3809Z",
    fill: "#97AEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.e88283dcb8b3f943a4e145d083d9aae5.svg";
export { ForwardRef as ReactComponent };